import { SC, CC } from "@bigspring/core-components";
import { motion } from "framer-motion";
import { Button } from "@shared/Button";
import { MenuItem as MuiMenuItem } from "@mui/material";

export const Wrapper = SC.styled.nav<{ $isNewAdminNav?: boolean }>`
  position: relative;
  z-index: 1;
  ${({ $isNewAdminNav }) =>
    $isNewAdminNav &&
    SC.css`
      position: sticky;
      top: 0;
      bottom: 0;
      left: 0;
      height: 100vh;
    `}
`;

export const Menu = SC.styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 20;
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.radix.colors.white};
  filter: drop-shadow(
      0px 2px 2px
        ${({ theme }) => theme.kinetic.v2.palette.rgba.grayTextDark(0.16)}
    )
    drop-shadow(
      0px 2px 8px
        ${({ theme }) => theme.kinetic.v2.palette.rgba.grayTextDark(0.24)}
    );

  @media (max-width: 700px) {
    width: 100%;
  }
`;

export const MenuIcon = SC.styled(motion.div)`
  position: absolute;
  top: 20px;
  left: 0;
  z-index: 10;
  cursor: pointer;
  padding-left: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid ${({ theme }) =>
    theme.kinetic.v2.palette.rgb.grayUiLight};
`;

export const Header = SC.styled(CC.Grid)`
  border-bottom: 1px solid
    ${({ theme }) => theme.kinetic.v2.palette.rgb.grayUiLight};
  padding: 20px;
`;

export const MenuOpenIcon = SC.styled(CC.MenuOpenIcon)`
  cursor: pointer;
`;

export const BigSpringLogo = SC.styled(CC.BigSpringMarkIcon)`
  width: 125px;
  height: 24px;
`;

export const BigSpringLogoV2 = SC.styled(CC.BigSpringMarkV2Icon)`
  width: 125px;
  height: 24px;
`;

export const CompanySelector = SC.styled(Button)<{ $isNewAdminNav?: boolean }>`
  border: none;
  border-radius: 0;
  box-shadow: none !important;
  padding: 12px 26px;
  margin-bottom: 5px;
  &:hover, &:focus-visible {
    border: none;
    background-color: transparent;
  }
  span {
    font-size: 16px;
    line-height: 24px;
    color: ${({ theme, $isNewAdminNav }) =>
      $isNewAdminNav ? "black" : theme.radix.colors.gray.gray1} !important;
    svg {
      fill: ${({ theme, $isNewAdminNav }) =>
        $isNewAdminNav ? "black" : theme.radix.colors.gray.gray1} !important;
    }
  }
`;

export const PinnedMenuItem = SC.styled(MuiMenuItem)<{
  $color?: "primary" | "default";
}>`
  min-height: 45px;
  padding: 6px 22px;
  white-space: normal;
  overflow-wrap: break-word;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;

  .company-name {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .pin-icon {
    opacity: 0;
    transition: opacity 0.2s ease;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    border-radius: 4px;
    color: #6E6E6B;

    &:hover {
      background-color: rgba(0, 0, 0, 0.04);
    }

    &.pinned {
      opacity: 1;
      color: ${({ theme }) => theme.kinetic.v2.palette.rgb.magenta};
    }
  }

  &:hover .pin-icon {
    opacity: 1;
  }

  &.Mui-selected {
    color: ${({ theme, $color }) =>
      $color === "primary" ? theme.radix.colors.blue.blue2 : "#555553"};
    background-color: transparent;

    svg {
      margin-left: auto;
      path {
        fill: ${({ theme, $color }) =>
          $color === "primary"
            ? theme.radix.colors.blue.blue2
            : "#555553"} !important;
      }
    }

    &:hover {
      background-color: ${({ theme, $color }) =>
        $color === "primary" ? theme.radix.colors.blue.blue1 : "transparent"};
    }
  }

  &:hover {
    background-color: ${({ theme, $color }) =>
      $color === "primary" ? theme.radix.colors.blue.blue1 : "transparent"};
  }
`;
